import { ChangeDetectorRef, Component, ErrorHandler, Injector, OnDestroy, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core'

import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'

import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'

import { AsiakasKopioija } from '../../_angular/service/asiakas/asiakas.kopioija'
import { AsiakasService } from '../../_angular/service/asiakas/asiakas.service'

import { BehaviorSubject, combineLatest, distinctUntilChanged, firstValueFrom, map, Observable, of, Subject, switchMap, takeUntil } from 'rxjs'

import { DebugService } from 'app/_angular/service/debug.service'
import { FirebaseLemonaid, FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import {
  Asiakas,
  AsiakkaanSopimuskaudenTauko,
  AsiakkaanSopimuskaudenTila,
  AsiakkaanSopimuskausi,
  AsiakkaanSopimusversio,
  PakotaSopimuksenUudelleenAllekirjoitusPyynto,
  PakotaSopimuksenUudelleenAllekirjoitusVastaus,
  PerutaSopimuksenPaattyminenPyynto,
  PerutaSopimuksenPaattyminenVastaus,
} from 'app/_jaettu-lemonator/model/asiakas'

import { FieldTree, form, required } from '@angular/forms/signals'
import { MatDatepicker } from '@angular/material/datepicker'
import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'
import { SopimusPalvelupaketti } from '@lemon/core-firebase/model/kayttaja'
import { SopimuksenHyvaksynnanHistoria } from '@lemon/core-firebase/model/sopimus'
import { LocalDate, NumberDate } from '@lemon/core/model/common'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { TimestampProviderBase } from '@lemon/core/service/timestamp-provider.interface'
import { KirjanpitajaService } from 'app/_angular/service/kirjanpitaja/kirjanpitaja.service'
import { AreYouSureDialog, AreYouSureDialogData } from 'app/_jaettu-angular/_components/are-you-sure.dialog'
import { arvonMuutokset, asetaArvo, nollaa } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from 'app/_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { FormValidators } from 'app/_jaettu-angular/_validators/FormValidators'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { AsiakasJaettuService } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'
import { AsiakkaanSopimuskausiService } from 'app/_jaettu-lemonator/service/sopimuskausi.service'
import { AsiakkaanSopimuskausiPaataDialog, AsiakkaanSopimuskausiPaataDialogData } from './sopimuskausi-paata.dialog'
import { AsiakkaanSopimuskausiTaukoDialog, AsiakkaanSopimuskausiTaukoDialogData } from './sopimuskausi-tauko.dialog'
import { AsiakkaanSopimuskausiUusiDialog, AsiakkaanSopimuskausiUusiDialogData } from './sopimuskausi-uusi.dialog'
import { SopimusversioLomake } from './sopimusversio.component'

const TYHJA_SOPIMUSVERSIO: SopimusversioLomake = { palvelupaketti: null, palkat: null, sopimusversioVoimassaAlkaen: null }

interface AsiakkaanTietojenMuokkausLomake {
  naytaKayttajilleTervetuloaDialogi: boolean
  vaadiKayttajiltaUusiTunnistautuminen: boolean
  vaadiPepTietojenPaivittaminen: boolean
  vaadiSopimuksenAllekirjoittaminenUudelleen: boolean
}

interface SopimuskaudenTaukorivi {
  tauko: AsiakkaanSopimuskaudenTauko
  naytetaankoMuokkaaNappi: boolean
  luoja: string
  paivittaja: string
}

interface SopimuskaudenHyvaksyntarivi {
  hyvaksynta: SopimuksenHyvaksynnanHistoria
  hyvaksyja: string
}

interface SopimuskausiDisplayed {
  kausi: AsiakkaanSopimuskausi
  valittuVersio: AsiakkaanSopimusversio
  onkoAiempiaVersioita: boolean
  onkoSeuraaviaVersiota: boolean
  syyOtsikko: string
  syy: string
  lisatiedot: string
  onkoPurku: boolean
  sopimusPaattyyPianEmailDate: LocalDate
  sopimusOnPaattynytEmailDate: LocalDate
  devaaja: boolean
  naytaLaitaTauolle: boolean
  naytaPakotaSopimuksenAllekirjoitus: boolean
  naytaPeruutaSopimuksenPaattyminen: boolean
  laskutusAlkaa: string
  tauot: SopimuskaudenTaukorivi[]
  poytalaatikot: SopimuskaudenTaukorivi[]
  hyvaksynnat: SopimuskaudenHyvaksyntarivi[]
  tila: AsiakkaanSopimuskaudenTila
  tilanNimi: string
  // tilanVarikoodi: string
  luoja: string
  paivittaja: string
  isEditing: boolean
}

@Component({
  templateUrl: './sopimuskaudet-v2.component.html',
  styleUrls: ['./sopimuskaudet-v2.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakasAsetuksetSopimuskaudetV2Component implements OnInit, OnDestroy {
  private _ngUnsubscribe: Subject<void> = new Subject<void>()
  private readonly _injector = inject(Injector)

  readonly asiakas = signal<Asiakas>(null)
  readonly sopimuskausiError = signal<string>(null)

  asiakasUriObservable: Observable<string>
  asiakasEncodedUriObservable: Observable<string>
  kirjanpitajaOnDevaajaObservable: Observable<boolean>
  naytaLisaaObservable: Observable<boolean>
  isLastPriceZero: boolean

  readonly sopimuskaudetCache = signal<SopimuskausiDisplayed[]>(undefined)
  private _valittuSopimuskausiVersioMapSubject: BehaviorSubject<Map<AsiakkaanSopimuskausi['avain'], AsiakkaanSopimusversio>> = new BehaviorSubject(new Map())

  private _uusiSopimuskausiVersioCache: AsiakkaanSopimusversio & { sopimuskausiAvain: string; sopimusAlkaa: NumberDate } = {
    avain: null,
    sopimuskausiAvain: null,
    sopimusAlkaa: null,
    palvelupaketti: null,
    lisapalvelut: {},
    luotu: null,
    luoja: null,
    voimassaAlkaen: null,
    allekirjoitusStatus: 'ei-allekirjoitettu',
  }

  sopimusversioLomake: FieldTree<SopimusversioLomake>
  asiakkaanTietojenMuokkausLomake = form(
    signal<AsiakkaanTietojenMuokkausLomake>({
      naytaKayttajilleTervetuloaDialogi: false,
      vaadiKayttajiltaUusiTunnistautuminen: false,
      vaadiPepTietojenPaivittaminen: false,
      vaadiSopimuksenAllekirjoittaminenUudelleen: false,
    }),
  )
  kirjanpitajaOnLuottoObservable: Observable<boolean>

  palvelupaketit = this._sopimuskausiService.palvelupaketit

  constructor(
    private _dialog: MatDialog,
    private _asiakasService: AsiakasService,
    private _dateService: DateService,
    private _asiakasKopioija: AsiakasKopioija,
    private _errorHandler: ErrorHandler,
    private _ladataanService: LadataanService,
    private _snackbar: MatSnackBar,
    private _firebase: FirebaseLemonator,
    private _lemonaidFirebase: FirebaseLemonaid,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _asiakasJaettuService: AsiakasJaettuService,
    private _debugService: DebugService,
    private _kirjanpitajaService: KirjanpitajaService,
    private _currencyService: CurrencyService,
    private _sopimuskausiService: AsiakkaanSopimuskausiService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _timestampService: TimestampProviderBase,
    private _validationService: FormValidationService,
  ) {
    this.asiakas.set(this._asiakasKopioija.annaUusiAsiakas())
  }

  ngOnInit() {
    this.kirjanpitajaOnLuottoObservable = this._kirjautunutKayttajaService.kirjanpitajaOnLuottoObservable

    const sopimustenHyvaksynnatObservable = this._asiakasService.nykyinenAsiakasAvainObservable.pipe(
      switchMap(asiakas => {
        if (asiakas) {
          return this._lemonaidFirebase.firestoreCollectionGroup<SopimuksenHyvaksynnanHistoria>('sopimus-hyvaksynnat-full-history').where('asiakasAvain', '==', asiakas.avain).listen()
        }
        return of<SopimuksenHyvaksynnanHistoria[]>([])
      }),
    )

    const kayttajatNimiMapObservable: Observable<Map<string, string>> = this._asiakasService.nykyisenAsiakkaanKayttajatObservable.pipe(
      map(kayttajat => {
        const m: Map<string, string> = new Map()
        if (kayttajat) {
          for (const kayttaja of kayttajat) {
            m.set(kayttaja.avain, kayttaja.etunimi + ' ' + kayttaja.sukunimi)
          }
        }
        return m
      }),
    )

    const sopimuskaudetObservable = combineLatest([
      this._asiakasService.nykyinenAsiakasObservable,
      this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiObservable,
      this._kirjautunutKayttajaService.getKirjanpitajanTiedot(),
      sopimustenHyvaksynnatObservable,
      this._kirjanpitajaService.kirjanpitajienNimitiedotMapObservable,
      kayttajatNimiMapObservable,
      this._valittuSopimuskausiVersioMapSubject.asObservable(),
    ]).pipe(
      map(([asiakas, devaajaTaiTuki, kirjanpitaja, sopimuksenHyvaksynnat, kirjanpitajatNimiMap, kayttajaNimiMap, valittuSopimuskausiVersioMap]) => {
        const sopimuskaudet = asiakas?.sopimuskaudet || []

        return sopimuskaudet.map((kausi, idx) => {
          const sopimusversio = valittuSopimuskausiVersioMap?.has(kausi.avain) ? valittuSopimuskausiVersioMap.get(kausi.avain) : this._sopimuskausiService.annaVoimassaOlevaSopimusversio(kausi)

          /** Newer way of matching sopimukset and signature data */
          const kaikkiTamanVersionAllekirjoitukset = sopimusversio ? sopimuksenHyvaksynnat.filter(sh => sh.asiakkaanSopimusversionAvain === sopimusversio.avain) : null

          /** Older way of matching sopimukset and signature data, used as fallback */
          const kaikkiTamanKaudenAllekirjoitukset = sopimuksenHyvaksynnat.filter(sh => {
            const allekirjoituksenPaiva = this._dateService.dateToLocalDate(this._dateService.timestampToDate(sh.pvm))
            return this._dateService.compareLocalDates(kausi.alkaa, '<=', allekirjoituksenPaiva) && (!kausi.loppuu || this._dateService.compareLocalDates(allekirjoituksenPaiva, '<=', kausi.loppuu))
          })

          const allekirjoitukset = kaikkiTamanVersionAllekirjoitukset || kaikkiTamanKaudenAllekirjoitukset

          const kuukaudenHintaJaSeuraava = this._asiakasJaettuService.annaHintaKuukaudelleJaSeuraavaHinta(asiakas, kausi.alkaa)
          let laskutusAlkaa = 'Hinta puuttuu'
          if (kuukaudenHintaJaSeuraava.voimassaOleva) {
            const alku = this._dateService.maxLocalDate(kuukaudenHintaJaSeuraava.voimassaOleva.voimassaAlkaen, kausi.alkaa, this._dateService.timestampToLocalDate(kausi.luotu))
            laskutusAlkaa = this._formatoiHinta(alku, kuukaudenHintaJaSeuraava.voimassaOleva.hinta)
          } else if (kuukaudenHintaJaSeuraava.seuraava) {
            laskutusAlkaa = this._formatoiHinta(kuukaudenHintaJaSeuraava.seuraava.voimassaAlkaen, kuukaudenHintaJaSeuraava.seuraava.hinta)
          }

          const luoja = kirjanpitajatNimiMap.get(kausi.luoja)
          const paivittaja = kirjanpitajatNimiMap.get(kausi.paivittaja)
          const tila = this._sopimuskausiService.annaSopimuskaudenTietynSopimusversionTila(kausi, sopimusversio, this._dateService.currentLocalDate(), allekirjoitukset)
          const onkoPurku = this._sopimuskausiService.onkoPurku(kausi.lopettamisenSyy)
          const onkoLopetus = this._sopimuskausiService.onkoLopetus(kausi.lopettamisenSyy)
          const tauot: AsiakkaanSopimuskaudenTauko[] = kausi.tauot ?? []
          const mappedTauot = tauot.map((tauko, index) => {
            const taukoLuoja = kirjanpitajatNimiMap.get(tauko.luoja)
            const taukoPaivittaja = kirjanpitajatNimiMap.get(tauko.paivittaja)
            const r: SopimuskaudenTaukorivi = {
              tauko: tauko,
              naytetaankoMuokkaaNappi: tauot.length === index + 1,
              luoja: taukoLuoja ? taukoLuoja.etunimi + ' ' + taukoLuoja.sukunimi : 'Luojaa EI löydy!',
              paivittaja: taukoPaivittaja ? taukoPaivittaja.etunimi + ' ' + taukoPaivittaja.sukunimi : 'Paivittajaa EI löydy!',
            }
            return r
          })

          const onkoSuperUser = kirjanpitaja.rooli === KirjanpitajanRooli.SUPER
          const mapped: SopimuskausiDisplayed = {
            valittuVersio: sopimusversio,
            kausi: kausi,
            lisatiedot: kausi.lisatiedot ?? null,
            syy: null,
            syyOtsikko: onkoPurku ? 'Purkamisen syy' : 'Päättymisen syy',
            onkoPurku: onkoPurku,
            sopimusPaattyyPianEmailDate: this._sopimuskausiService.annaSopimusPaattyyPianEmailDate(kausi),
            sopimusOnPaattynytEmailDate: this._sopimuskausiService.annaSopimusOnPaattynytEmailDate(kausi),
            devaaja: devaajaTaiTuki,
            laskutusAlkaa: laskutusAlkaa,
            naytaLaitaTauolle: !tauot.find(tauko => !tauko.loppuu),
            naytaPakotaSopimuksenAllekirjoitus: allekirjoitukset.length > 0 && devaajaTaiTuki && idx + 1 === asiakas.sopimuskaudet.length,
            naytaPeruutaSopimuksenPaattyminen: onkoLopetus || onkoPurku,
            tauot: mappedTauot.filter(t => t.tauko.tyyppi === 'tauko'),
            poytalaatikot: mappedTauot.filter(t => t.tauko.tyyppi === 'poytalaatikko'),
            hyvaksynnat: allekirjoitukset.map(hyvaksynta => {
              const hyvaksyja = kayttajaNimiMap.get(hyvaksynta.kayttajaAvain)
              const h: SopimuskaudenHyvaksyntarivi = {
                hyvaksyja: hyvaksyja ? hyvaksyja : 'Hyväksyjää EI löydy!',
                hyvaksynta: hyvaksynta,
              }
              return h
            }),
            tila: tila,
            tilanNimi: this._sopimuskausiService.annaTilanNimi(tila),
            // tilanVarikoodi: this._asiakkaanSopimuskausiService.annaTilanVarikoodi(tila),
            luoja: luoja ? luoja.etunimi + ' ' + luoja.sukunimi : 'Luojaa EI löydy!',
            paivittaja: paivittaja ? paivittaja.etunimi + ' ' + paivittaja.sukunimi : 'Paivittajaa EI löydy!',
            onkoAiempiaVersioita: !!this._getPrevOrNextSopimusVersioPrevOrNextIndexIfExists('prev', sopimusversio, kausi.sopimusversiot),
            onkoSeuraaviaVersiota: !!this._getPrevOrNextSopimusVersioPrevOrNextIndexIfExists('next', sopimusversio, kausi.sopimusversiot),
            isEditing: false,
          }

          if (kausi.lopettamisenSyy) {
            mapped.syy = this._sopimuskausiService.lokalisoidutSopimuksenLopettamissyyt.find(syy => syy.arvo === kausi.lopettamisenSyy)?.nimi ?? null
          }
          return mapped
        })
      }),
    )

    sopimuskaudetObservable
      .pipe(
        takeUntil(this._ngUnsubscribe),
        distinctUntilChanged((a, b) => {
          if (a.length !== b.length) {
            return false
          }

          for (const [idx, aSk] of a.entries()) {
            if (
              aSk.kausi.sopimusversiot?.length !== b[idx].kausi.sopimusversiot?.length ||
              this._dateService.localDateToNumber(aSk.kausi.alkaa) !== this._dateService.localDateToNumber(b[idx].kausi.alkaa) ||
              this._dateService.localDateToNumber(aSk.kausi.loppuu) !== this._dateService.localDateToNumber(b[idx].kausi.loppuu) ||
              aSk.kausi.lopettamisenSyy !== b[idx].kausi.lopettamisenSyy ||
              aSk.laskutusAlkaa !== b[idx].laskutusAlkaa ||
              aSk.valittuVersio !== b[idx].valittuVersio
            ) {
              return false
            }
          }
          return true
        }),
      )
      .subscribe(sopimuskaudet => {
        this.sopimuskaudetCache.set(sopimuskaudet)
      })

    // Debug thingies
    this.kirjanpitajaOnDevaajaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaObservable
    this.asiakasUriObservable = this._asiakasService.nykyinenAsiakasAvainObservable.pipe(
      map(avainTiedot => {
        if (avainTiedot?.avain) {
          return 'asiakkaat/' + avainTiedot.avain
        }
        return ''
      }),
    )
    this.asiakasEncodedUriObservable = this.asiakasUriObservable.pipe(
      map(uri => {
        return this._debugService.createFirestoreLink(uri)
      }),
    )

    this._asiakasService.nykyinenAsiakasObservable
      .pipe(
        distinctUntilChanged((prev, curr) => prev?.avain === curr?.avain),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(asiakas => {
        if (asiakas) {
          this.asiakas.set(this._asiakasKopioija.kopioiAsiakas(asiakas))
        }
      })

    this.naytaLisaaObservable = this._asiakasService.nykyinenAsiakasObservable.pipe(map(asiakas => !asiakas?.sopimuskaudet?.find(kausi => !kausi.loppuu)))
  }

  private _formatoiHinta(pvm: LocalDate, hinta: number): string {
    return pvm.month + '/' + pvm.year + ' (' + this._currencyService.formatoiRaha(hinta, 'EUR', 'fi') + ')'
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  // poistaSopimuskausi(sopimuskausi: AsiakkaanSopimuskausi) {
  //   const index = this.asiakas.sopimuskaudet.findIndex(k => k.avain === sopimuskausi.avain)
  //   if (index > -1) {
  //     this.asiakas.sopimuskaudet.splice(index, 1)
  //   }
  // }

  async laitaTauolle(sopimuskausi: AsiakkaanSopimuskausi) {
    const tauko: AsiakkaanSopimuskaudenTauko = {
      alkaa: null,
      tyyppi: 'tauko',
      avain: this._firebase.firestoreCreateId(),
      loppuu: null,
      luoja: null,
      luotu: null,
      paivitetty: null,
      paivittaja: null,
      poistettu: false,
      muistutuspvm: this._dateService.lisaaKuukausiaPaikallinen(this._dateService.currentLocalDate(), 3),
    }
    await this.muokkaaTaukoa(sopimuskausi, tauko, true)
  }

  laitaPoytalaatikkoon(sopimuskausi: AsiakkaanSopimuskausi) {
    const tauko: AsiakkaanSopimuskaudenTauko = {
      alkaa: null,
      tyyppi: 'poytalaatikko',
      avain: this._firebase.firestoreCreateId(),
      loppuu: null,
      luoja: null,
      luotu: null,
      paivitetty: null,
      paivittaja: null,
      poistettu: false,
    }
    this.muokkaaTaukoa(sopimuskausi, tauko, true)
  }

  async muokkaaTaukoa(sopimuskausi: AsiakkaanSopimuskausi, tauko: AsiakkaanSopimuskaudenTauko, uusi: boolean) {
    const data: AsiakkaanSopimuskausiTaukoDialogData = {
      asiakas: this.asiakas(),
      kausi: sopimuskausi,
      tauko: tauko,
      uusi: uusi,
    }

    const dialogNgUnsubscribe: Subject<void> = new Subject<void>()
    this._dialog
      .open<AsiakkaanSopimuskausiTaukoDialog, AsiakkaanSopimuskausiTaukoDialogData, void>(AsiakkaanSopimuskausiTaukoDialog, {
        data: data,
      })
      .afterClosed()
      .pipe(takeUntil(dialogNgUnsubscribe))
      .subscribe({
        next: () => {},
        error: err => {
          this._errorHandler.handleError(err)
          dialogNgUnsubscribe.next()
          dialogNgUnsubscribe.complete()
        },
        complete: () => {
          dialogNgUnsubscribe.next()
          dialogNgUnsubscribe.complete()
        },
      })
  }

  muokkaaAsiakkaanAsetuksia(): Promise<any> {
    this._ladataanService.aloitaLataaminen()
    const pyynto: PakotaSopimuksenUudelleenAllekirjoitusPyynto = {
      asiakasAvain: this.asiakas().avain,
      naytaKayttajilleTervetuloaDialogi: this.asiakkaanTietojenMuokkausLomake.naytaKayttajilleTervetuloaDialogi().value(),
      vaadiKayttajiltaUusiTunnistautuminen: this.asiakkaanTietojenMuokkausLomake.vaadiKayttajiltaUusiTunnistautuminen().value(),
      vaadiPepTietojenPaivittaminen: this.asiakkaanTietojenMuokkausLomake.vaadiPepTietojenPaivittaminen().value(),
      vaadiSopimuksenAllekirjoittaminenUudelleen: this.asiakkaanTietojenMuokkausLomake.vaadiSopimuksenAllekirjoittaminenUudelleen().value(),
    }
    if (!pyynto.naytaKayttajilleTervetuloaDialogi && !pyynto.vaadiKayttajiltaUusiTunnistautuminen && !pyynto.vaadiPepTietojenPaivittaminen && !pyynto.vaadiSopimuksenAllekirjoittaminenUudelleen) {
      this._snackbar.open('EI TALLENNETTAVIA MUUTOKSIA. MITÄÄN EI TEHTY.', null, { duration: 3000 })
      return
    }
    return this._firebase
      .functionsCall<PakotaSopimuksenUudelleenAllekirjoitusPyynto, PakotaSopimuksenUudelleenAllekirjoitusVastaus>('sopimuksenUudelleenAllekirjoittaminenPakotetusti', pyynto)
      .then(() => {
        this._snackbar.open('Muutokset tallennettiin.', null, { duration: 3000 })
      })
      .catch(error => {
        this._errorHandler.handleError(error)
      })
      .finally(() => {
        asetaArvo(this.asiakkaanTietojenMuokkausLomake.naytaKayttajilleTervetuloaDialogi, false)
        asetaArvo(this.asiakkaanTietojenMuokkausLomake.vaadiKayttajiltaUusiTunnistautuminen, false)
        asetaArvo(this.asiakkaanTietojenMuokkausLomake.vaadiPepTietojenPaivittaminen, false)
        asetaArvo(this.asiakkaanTietojenMuokkausLomake.vaadiSopimuksenAllekirjoittaminenUudelleen, false)
        this._ladataanService.lopetaLataaminen()
      })
  }

  async paataSopimuskausi(sopimuskausi: AsiakkaanSopimuskausi) {
    this.sopimuskausiError.set(null)
    const data: AsiakkaanSopimuskausiPaataDialogData = {
      asiakas: this.asiakas(),
      kausi: sopimuskausi,
    }
    const dialogNgUnsubscribe: Subject<void> = new Subject<void>()
    this._dialog
      .open<AsiakkaanSopimuskausiPaataDialog, AsiakkaanSopimuskausiPaataDialogData, void>(AsiakkaanSopimuskausiPaataDialog, {
        data: data,
      })
      .afterClosed()
      .pipe(takeUntil(dialogNgUnsubscribe))
      .subscribe({
        next: () => {},
        error: err => {
          this._errorHandler.handleError(err)
          dialogNgUnsubscribe.next()
          dialogNgUnsubscribe.complete()
        },
        complete: () => {
          dialogNgUnsubscribe.next()
          dialogNgUnsubscribe.complete()
        },
      })
  }

  async lisaaSopimuskausi() {
    const asiakas = await firstValueFrom(this._asiakasService.nykyinenAsiakasObservable)
    if (asiakas.sopimuskaudet?.find(kausi => !kausi.loppuu)) {
      this.sopimuskausiError.set('Päätä edellinen sopimuskausi ennen uuden lisäämistä.')
      return
    }
    this.sopimuskausiError.set(null)

    const dialogNgUnsubscribe: Subject<void> = new Subject<void>()
    const data: AsiakkaanSopimuskausiUusiDialogData = {
      asiakas: this.asiakas(),
    }
    this._dialog
      .open<AsiakkaanSopimuskausiUusiDialog, AsiakkaanSopimuskausiUusiDialogData, void>(AsiakkaanSopimuskausiUusiDialog, {
        data: data,
      })
      .afterClosed()
      .pipe(takeUntil(dialogNgUnsubscribe))
      .subscribe({
        next: () => {
          // if (kausi) {
          //   if (!this.asiakas.sopimuskaudet) {
          //     this.asiakas.sopimuskaudet = []
          //   }
          //   this.asiakas.sopimuskaudet.push(kausi)
          // }
        },
        error: err => {
          this._errorHandler.handleError(err)
          dialogNgUnsubscribe.next()
          dialogNgUnsubscribe.complete()
        },
        complete: () => {
          dialogNgUnsubscribe.next()
          dialogNgUnsubscribe.complete()
        },
      })
  }

  async pakotaSopimuksenAllekirjoittaminenUudelleen() {
    const isSure = await firstValueFrom(
      this._dialog
        .open<AreYouSureDialog, AreYouSureDialogData>(AreYouSureDialog, {
          data: { rightAction: 'Pakota', text: 'Oletko varma, että haluat pakottaa käyttäjät allekirjoittamaan sopimuksen uudelleen?' },
        })
        .afterClosed(),
    )

    if (!isSure) {
      return
    }

    if (this.asiakas() && this.asiakas().avain) {
      this._ladataanService.aloitaLataaminen()
      const pyynto: PakotaSopimuksenUudelleenAllekirjoitusPyynto = {
        asiakasAvain: this.asiakas().avain,
        naytaKayttajilleTervetuloaDialogi: false,
        vaadiKayttajiltaUusiTunnistautuminen: false,
        vaadiPepTietojenPaivittaminen: false,
        vaadiSopimuksenAllekirjoittaminenUudelleen: true,
      }
      this._firebase
        .functionsCall<PakotaSopimuksenUudelleenAllekirjoitusPyynto, PakotaSopimuksenUudelleenAllekirjoitusVastaus>('sopimuksenUudelleenAllekirjoittaminenPakotetusti', pyynto)
        .then(() => {
          this._ladataanService.lopetaLataaminen()
        })
        .catch(error => {
          this._ladataanService.lopetaLataaminen()
          this._errorHandler.handleError(error)
        })
    } else {
      this._errorHandler.handleError(new Error('Asiakas puuttuu!! ' + JSON.stringify(this.asiakas())))
    }
  }

  async peruutaSopimuksenPaattyminen(sopimuskausiAvain: string) {
    const isSure = await firstValueFrom(
      this._dialog
        .open<AreYouSureDialog, AreYouSureDialogData>(AreYouSureDialog, {
          data: { leftAction: 'Sulje dialogi', rightAction: 'Vahvista päättymisen peruminen', text: 'Oletko varma, että haluat perua sopimuksen päättymisen?' },
        })
        .afterClosed(),
    )

    if (!isSure) {
      return
    }

    if (this.asiakas() && this.asiakas().avain) {
      this._ladataanService.aloitaLataaminen()
      const pyynto: PerutaSopimuksenPaattyminenPyynto = {
        asiakasAvain: this.asiakas().avain,
        sopimuskausiAvain: sopimuskausiAvain,
      }
      return this._firebase
        .functionsCall<PerutaSopimuksenPaattyminenPyynto, PerutaSopimuksenPaattyminenVastaus>('sopimuksenPaattyminenPeruta', pyynto)
        .then(resp => {
          if (!resp || resp.e) {
            this._errorHandler.handleError(new Error('Sopimuksen päättämisen peruminen epäonnistui! ' + (resp?.e ?? 'Tuntematon virhe')))
          } else {
            this._snackbar.open('Sopimuksen päättyminen peruttu.', 'OK', { duration: 5000 })
          }
        })
        .catch(err => {
          this._errorHandler.handleError(new Error('Sopimuksen päättämisen peruminen epäonnistui tuntematon virheen takia!'))
        })
        .finally(() => {
          this._ladataanService.lopetaLataaminen()
        })
    }
  }

  annaMinimiPaivamaara<T>(kentta: FieldTree<T>): Date {
    if (!kentta().disabled()) {
      const d = new Date()
      d.setDate(1)
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      d.setMilliseconds(1)
      return this._dateService.lisaaKuukausia(d, 1)
    }
    return new Date(1980, 1, 1)
  }

  chosenMonthHandler(normalizedMonth: Date, kentta: FieldTree<Date>, datepicker: MatDatepicker<Date>) {
    const minDate = this.annaMinimiPaivamaara(kentta)
    if (this._dateService.kuukausiaValissa(normalizedMonth, minDate) > -1) {
      asetaArvo(kentta, normalizedMonth)
      kentta().markAsTouched()
    }
    datepicker.close()
  }

  vaihdaSopimuskausiVersio(sopimuskausiBox: SopimuskausiDisplayed, direction: 'prev' | 'next') {
    const valittuVersio = this._getPrevOrNextSopimusVersioPrevOrNextIndexIfExists(direction, sopimuskausiBox.valittuVersio, sopimuskausiBox.kausi.sopimusversiot)
    if (!valittuVersio) {
      return
    }

    const valittuSopimuskausiVersioMap = this._valittuSopimuskausiVersioMapSubject.value
    valittuSopimuskausiVersioMap.set(sopimuskausiBox.kausi.avain, valittuVersio)
    this._valittuSopimuskausiVersioMapSubject.next(valittuSopimuskausiVersioMap)
  }

  private _getPrevOrNextSopimusVersioPrevOrNextIndexIfExists(direction: 'prev' | 'next', valittuVersio: AsiakkaanSopimusversio, sopimusversiot: AsiakkaanSopimusversio[]) {
    if (!valittuVersio || (sopimusversiot?.length || 0) < 2) {
      return null
    }

    sopimusversiot.sort((a, b) => a.luotu.toMillis() - b.luotu.toMillis()) // Guarantee order
    const currentIdx = sopimusversiot.findIndex(v => v.avain === valittuVersio.avain)

    if (direction === 'prev' && currentIdx > 0) {
      return sopimusversiot[currentIdx - 1]
    }

    if (direction === 'next' && currentIdx < sopimusversiot.length - 1) {
      return sopimusversiot[currentIdx + 1]
    }

    return null
  }

  toggleIsEditing(isEditing: boolean, sopimuskausiBox: SopimuskausiDisplayed) {
    for (const sopimuskausi of this.sopimuskaudetCache()) {
      // Reset all others
      sopimuskausi.isEditing = false
    }
    if (!this.sopimusversioLomake) {
      this.sopimusversioLomake = this._createSopimusversioForm(sopimuskausiBox)
    } else if (sopimuskausiBox.kausi.avain !== this._uusiSopimuskausiVersioCache.sopimuskausiAvain) {
      this._resetSopimusForm(sopimuskausiBox)
    }
    sopimuskausiBox.isEditing = isEditing
    this._changeDetectorRef.markForCheck()
  }

  async tallennaMuutokset(toBeSaved: SopimuskausiDisplayed) {
    if (!this.sopimusversioLomake().valid()) {
      this._validationService.merkitseKokoLomakeKosketuksi(this.sopimusversioLomake)
      return
    }

    const onkoHolviZenPaketti = this._uusiSopimuskausiVersioCache.palvelupaketti === SopimusPalvelupaketti.HOLVI_ZEN
    const areYouSureDialogData: AreYouSureDialogData = {
      text: !onkoHolviZenPaketti
        ? 'Palvelukokonaisuuden muutokset lähetetään Lemonaidiin hyväksyttäväksi. Sopimuksen hyväksyjä -roolin omaavat käyttäjät voivat hyväksyä muutokset. Kuittaus tallennetaan Lemonatoriin.'
        : 'Palvelukokonaisuuden muutokset tallennetaan Lemonatoriin.',
      rightAction: !onkoHolviZenPaketti ? 'Lähetä' : 'Tallenna',
    }
    const isSure = await firstValueFrom(this._dialog.open<AreYouSureDialog, AreYouSureDialogData, boolean>(AreYouSureDialog, { data: areYouSureDialogData }).afterClosed())

    if (!isSure) {
      this.toggleIsEditing(false, toBeSaved)
      return
    }

    try {
      this._ladataanService.aloitaLataaminen()

      const kayttaja = await this._kirjautunutKayttajaService.getKirjanpitajanTiedot()

      for (const sopimuskausi of this.asiakas().sopimuskaudet) {
        if (sopimuskausi.avain === this._uusiSopimuskausiVersioCache.sopimuskausiAvain) {
          if (!sopimuskausi.sopimusversiot) {
            sopimuskausi.sopimusversiot = []
          }

          const uusiSopimusversio: AsiakkaanSopimusversio = {
            avain: this._firebase.firestoreCreateId(),
            palvelupaketti: this._uusiSopimuskausiVersioCache.palvelupaketti,
            lisapalvelut: this._uusiSopimuskausiVersioCache.lisapalvelut,
            luoja: kayttaja.uid,
            luotu: this._timestampService.now(),
            voimassaAlkaen: this._uusiSopimuskausiVersioCache.voimassaAlkaen,
            allekirjoitusStatus: onkoHolviZenPaketti ? 'allekirjoitettu' : 'ei-allekirjoitettu',
          }
          sopimuskausi.sopimusversiot.push(uusiSopimusversio)

          sopimuskausi.uusinSopimusversio = uusiSopimusversio.avain
          sopimuskausi.paivitetty = this._timestampService.now()
          sopimuskausi.paivittaja = kayttaja.uid
        }
      }
      await this._asiakasService.paivitaAsiakas(this.asiakas(), 'tilikaudet-eivat-voineet-muuttua', true, false)

      if (onkoHolviZenPaketti) {
        // Ei tarvitse lähettää hyväksyttäväksi, tallennetaan vain ja poistutaan muokkaustilasta
        return this.toggleIsEditing(false, toBeSaved)
      }

      const pyynto: PakotaSopimuksenUudelleenAllekirjoitusPyynto = {
        asiakasAvain: this.asiakas().avain,
        naytaKayttajilleTervetuloaDialogi: false,
        vaadiKayttajiltaUusiTunnistautuminen: false,
        vaadiPepTietojenPaivittaminen: false,
        vaadiSopimuksenAllekirjoittaminenUudelleen: true,
      }

      await this._firebase.functionsCall<PakotaSopimuksenUudelleenAllekirjoitusPyynto, PakotaSopimuksenUudelleenAllekirjoitusVastaus>('sopimuksenUudelleenAllekirjoittaminenPakotetusti', pyynto)

      this.toggleIsEditing(false, toBeSaved)
    } catch (err) {
      this._errorHandler.handleError(err)
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }

  private _createSopimusversioForm(sopimuskausi: SopimuskausiDisplayed): FieldTree<SopimusversioLomake> {
    const minDate = this._laskeSopimusversionMinimiAlkamispaiva(sopimuskausi)
    const sopimusversioLomake = form(
      signal<SopimusversioLomake>(TYHJA_SOPIMUSVERSIO),
      polku => {
        required(polku.palvelupaketti)
        required(polku.sopimusversioVoimassaAlkaen)
        validoiReaktiivisesti(polku.sopimusversioVoimassaAlkaen, FormValidators.minDateValidator(minDate))
      },
      { injector: this._injector },
    )
    const muutokset = <T>(kentta: FieldTree<T>) => arvonMuutokset(kentta, { injector: this._injector }).pipe(takeUntil(this._ngUnsubscribe))

    muutokset(sopimusversioLomake.palvelupaketti).subscribe(val => {
      this._uusiSopimuskausiVersioCache.palvelupaketti = val
    })
    muutokset(sopimusversioLomake.palkat).subscribe(val => {
      this._uusiSopimuskausiVersioCache.lisapalvelut.PALKAT = val
    })
    // sopimusForm.get('ennakkoverojenSeuranta').valueChanges.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
    //   this._uusiSopimuskausiVersioCache.lisapalvelut.ENNAKKOVEROJEN_SEURANTA = val
    // })
    // sopimusForm.get('ostolaskujenMaksaminen').valueChanges.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
    //   this._uusiSopimuskausiVersioCache.lisapalvelut.OSTOLASKUJEN_MAKSAMINEN = val
    // })
    // sopimusForm.get('kirjanpidonReskontra').valueChanges.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
    //   this._uusiSopimuskausiVersioCache.lisapalvelut.KIRJANPIDON_RESKONTRA = val
    // })
    // sopimusForm.get('myyntilaskujenLahettaminen').valueChanges.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
    //   this._uusiSopimuskausiVersioCache.lisapalvelut.MYYNTILASKUJEN_LAHETTAMINEN = val
    // })
    // sopimusForm.get('reskontranHoito').valueChanges.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
    //   this._uusiSopimuskausiVersioCache.lisapalvelut.RESKONTRAN_HOITO = val
    // })
    // sopimusForm.get('saatavienValvonta').valueChanges.pipe(takeUntil(this._ngUnsubscribe)).subscribe(val => {
    //   this._uusiSopimuskausiVersioCache.lisapalvelut.SAATAVIEN_VALVONTA = val
    // })
    muutokset(sopimusversioLomake.sopimusversioVoimassaAlkaen).subscribe(val => {
      if (val) {
        this._uusiSopimuskausiVersioCache.voimassaAlkaen = this._dateService.dateToNumber(val)
      }
    })

    this._uusiSopimuskausiVersioCache.sopimuskausiAvain = sopimuskausi.kausi.avain

    return sopimusversioLomake
  }

  private _resetSopimusForm(sopimuskausi: SopimuskausiDisplayed) {
    nollaa(this.sopimusversioLomake, TYHJA_SOPIMUSVERSIO)

    asetaArvo(this.sopimusversioLomake.palvelupaketti, sopimuskausi.valittuVersio?.palvelupaketti ?? null)
    asetaArvo(this.sopimusversioLomake.palkat, sopimuskausi.valittuVersio?.lisapalvelut?.PALKAT ?? null)
    // this.sopimusForm.get('ennakkoverojenSeuranta').setValue(sopimuskausi?.valittuVersio?.lisapalvelut?.ENNAKKOVEROJEN_SEURANTA)
    // this.sopimusForm.get('ostolaskujenMaksaminen').setValue(sopimuskausi?.valittuVersio?.lisapalvelut?.OSTOLASKUJEN_MAKSAMINEN)
    // this.sopimusForm.get('kirjanpidonReskontra').setValue(sopimuskausi?.valittuVersio?.lisapalvelut?.KIRJANPIDON_RESKONTRA)
    // this.sopimusForm.get('myyntilaskujenLahettaminen').setValue(sopimuskausi?.valittuVersio?.lisapalvelut?.MYYNTILASKUJEN_LAHETTAMINEN)
    // this.sopimusForm.get('reskontranHoito').setValue(sopimuskausi?.valittuVersio?.lisapalvelut?.RESKONTRAN_HOITO)
    // this.sopimusForm.get('saatavienValvonta').setValue(sopimuskausi?.valittuVersio?.lisapalvelut?.SAATAVIEN_VALVONTA)
    asetaArvo(this.sopimusversioLomake.sopimusversioVoimassaAlkaen, this._dateService.numberToDate(sopimuskausi?.valittuVersio?.voimassaAlkaen))

    this._uusiSopimuskausiVersioCache.sopimuskausiAvain = sopimuskausi.kausi.avain
  }

  private _laskeSopimusversionMinimiAlkamispaiva(sopimuskausi: SopimuskausiDisplayed): Date {
    let minDate = this._dateService.localDateToDate(sopimuskausi.kausi.alkaa)
    if (sopimuskausi.kausi.sopimusversiot && sopimuskausi.kausi.sopimusversiot.length > 0) {
      const viimeisinAlkamispaiva = sopimuskausi.kausi.sopimusversiot.reduce((max, v) => (v.voimassaAlkaen > max ? v.voimassaAlkaen : max), sopimuskausi.kausi.sopimusversiot[0].voimassaAlkaen)
      const minimiPvm = this._dateService.numberToDate(this._dateService.lisaaPaiviaNumber(viimeisinAlkamispaiva, 1))

      if (minimiPvm > minDate) {
        minDate = minimiPvm
      }
    }
    return minDate
  }
}
